<template>
  <div id="SetUpDialog_main">
    <el-dialog
      title="設定"
      :visible.sync="dialogVisible"
      width="60%"
      @close="closeDialog"
    >
      <el-tabs
        v-model="activeName"
        class="setUpTabs"
      >
        <!-- 訪客事由 -->
        <el-tab-pane
          label="訪客事由"
          name="first"
        >
          <div class="inputWrap">
            <p>新增事由</p>
            <el-input
              v-model="newGuestCause"
              maxlength="15"
              placeholder="最多15個字元"
            />
            <el-button
              size="mini"
              plain
              @click="createGuestCause"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            事由列表
          </p>
          <el-table
            class="list"
            :data="guestCauseList"
            ety-text="目前無訪客紀錄"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column label="訪客事由">
              <template slot-scope="scope">
                <p v-if="!scope.row.edited">
                  {{ scope.row.Name }}
                </p>
                <el-input
                  v-else
                  :ref="'eventInput'+scope.$index"
                  v-model="scope.row.Name"
                  maxlength="15"
                  placeholder="最多15個字元"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <div v-if="scope.$index < 2">
                  <span>預設</span>
                </div>
                <div v-else>
                  <el-button
                    v-if="scope.row.edited"
                    size="mini"
                    type="primary"
                    plain
                    @click="submitRow('訪客事由',scope.row)"
                  >
                    確定
                  </el-button>
                  <el-button
                    v-if="scope.row.edited"
                    size="mini"
                    plain
                    @click="cancelRow('訪客事由',scope.row)"
                  >
                    取消
                  </el-button>
                  <el-button
                    v-if="!scope.row.edited"
                    id="button"
                    size="mini"
                    :disabled="guestCauseEditing"
                    plain
                    @click="editRow('訪客事由',scope.row,scope.$index)"
                  >
                    編輯
                  </el-button>
                  <el-button
                    v-if="!scope.row.edited"
                    size="mini"
                    type="danger"
                    plain
                    @click="deleteRow('訪客事由',scope.row)"
                  >
                    刪除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>
        <!-- /訪客事由 -->
        <!-- 廠商 -->
        <el-tab-pane
          label="廠商"
          name="second"
        >
          <div class="inputWrap inputWrap2">
            <p>新增訪客廠商</p>
            <el-select
              v-model="newVendor.causeTypeId"
              placeholder="請選擇"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-model="newVendor.name"
              maxlength="15"
              placeholder="最多15個字元"
            />
            <el-button
              size="mini"
              plain
              @click="creatVendor"
            >
              新增
            </el-button>
          </div>
          <div class="selectVendor">
            <p class="tableTitle">
              廠商列表
            </p>
            <el-select
              v-if="selectVendorOptions.length > 0 "
              v-model="selectVendorValue"
              class="selectVendorOptions"
              placeholder="請選擇"
              @change="selectVendor"
            >
              <el-option
                v-for="item in selectVendorOptions"
                :key="item.value"
                :label="item.label+' ('+item.length+')'"
                :value="item.value"
              />
            </el-select>
          </div>
          <el-table
            class="list"
            :data="vendorTypeList"
            ety-text="目前無訪客紀錄"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              prop="CauseTypeName"
              label="訪客事由"
            />
            <el-table-column label="廠商">
              <template slot-scope="scope">
                <p v-if="!scope.row.edited">
                  {{ scope.row.Name }}
                </p>
                <el-input
                  v-else
                  :ref="'vendorInput'+scope.$index"
                  v-model="scope.row.Name"
                  maxlength="15"
                  placeholder="最多15個字元"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.edited"
                  size="mini"
                  type="primary"
                  plain
                  @click="submitRow('廠商',scope.row)"
                >
                  確定
                </el-button>
                <el-button
                  v-if="scope.row.edited"
                  size="mini"
                  plain
                  @click="cancelRow('廠商',scope.row)"
                >
                  取消
                </el-button>
                <el-button
                  v-if="!scope.row.edited"
                  id="button"
                  size="mini"
                  :disabled="vendorEditing"
                  plain
                  @click="editRow('廠商',scope.row,scope.$index)"
                >
                  編輯
                </el-button>
                <el-button
                  v-if="!scope.row.edited"
                  size="mini"
                  type="danger"
                  plain
                  @click="deleteRow('廠商',scope.row)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- /廠商 -->
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
export default {
  components: {
    TableLoading
  },
  data () {
    return {
      dialogVisible: false,
      activeName: 'first',
      guestCauseList: [], // 訪客事由列表
      allVendorTypeList: [], // 全部廠商列表
      vendorTypeList: [], // 廠商列表
      guestCauseEditing: false, // 訪客事由列表 是否正在編輯
      vendorEditing: false, // 廠商列表 是否正在編輯
      newGuestCause: '', // 新增事由input
      newVendor: { // 新增廠商事由input
        causeTypeId: 0,
        name: ''
      },
      options: [], // 新增廠商選項
      selectVendorOptions: [], // 篩選廠商選項
      value: 0,
      selectVendorValue: 0, // 篩選廠商
      loading: false,
      canClickButton: true, // 防止連點button參數
      isEdited: false // 判斷訪客紀錄兩張列表是否需要更新訪客事由資料
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible = true
      this.getGuestCauseList()
      this.getVendorTypeList()
    },
    closeDialog () {
      this.dialogVisible = false
      if (this.isEdited) // 資料有變動過，兩張列表需要更新訪客事由資料
      { this.$emit('getList') }
    },
    init () {
      this.guestCauseList = []
      this.vendorTypeList = []
      this.getGuestCauseList()
      this.getVendorTypeList()
      this.guestCauseEditing = false
      this.vendorEditing = false
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 取得訪客事由列表
    getGuestCauseList () {
      this.fullScreenLoading(true)
      this.selectVendorOptions = []
      this.options = [{
        value: 0,
        label: '請選擇'
      }]
      setTimeout(() => {
        apiGuest.SetUpDialog.GetGuestCauseType().then((res) => {
          res.data.forEach(item => {
            item.edited = false
            // 處理新增廠商下拉選單
            this.options.push({
              value: item.Id,
              label: item.Name
            })
            // 處理篩選廠商下拉選單
            this.selectVendorOptions.push({
              value: item.Id,
              label: item.Name,
              length: item.VendorTypes.length
            })
          })
          this.fullScreenLoading(false)
          this.guestCauseList = res.data
        }).catch((err) => {
          this.fullScreenLoading(false)
          console.log('錯誤訊息：', err.response)
        })
      }, 500)
    },
    // 取得廠商列表
    getVendorTypeList () {
      setTimeout(() => {
        apiGuest.SetUpDialog.GetVendorType().then((res) => {
          res.data.forEach(item => {
            item.edited = false
          })
          this.allVendorTypeList = res.data
          this.vendorTypeList = res.data
          this.selectVendorOptions.unshift({
            value: 0,
            label: '全部訪客事由',
            length: res.data.length
          })
          if (this.selectVendorValue !== 0) { this.selectVendor() }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
        })
      }, 500)
    },
    // 新增訪客事由
    createGuestCause () {
      if (this.canClickButton) {
        this.canClickButton = false
        if (this.newGuestCause === '') {
          this.alert('請輸入新增訪客事由', 'error', false)
          return
        }
        this.fullScreenLoading(true)
        const requestData = {
          name: this.newGuestCause
        }
        apiGuest.SetUpDialog.PostGuestCauseType(
          requestData
        ).then((res) => {
          if (res.status === 200) {
            this.newGuestCause = ''
            this.isEdited = true
            this.$message({
              type: 'success',
              message: '新增訪客事由成功'
            })
            this.init()
          } else {
            this.alert('新增訪客事由失敗', 'error')
            this.init()
          }
        }).catch((err) => {
          if (err.response.status === 400) {
            this.alert('請勿輸入已存在訪客事由', 'error')
            this.newGuestCause = ''
          }
          console.log('錯誤訊息：', err.response)
        })
      }
    },
    // 新增廠商
    creatVendor () {
      if (this.canClickButton) {
        this.canClickButton = false
        if (this.newVendor.causeTypeId === 0) {
          this.alert('新增失敗，請選擇新增訪客廠商的類別', 'error', false)
          return
        }

        if (this.newVendor.name === '') {
          this.alert('請輸入內容', 'error', false)
          return
        }

        if (this.newVendor.name && this.newVendor.name.length < 2) {
          this.alert('新增失敗，廠商名稱請輸入最少為 2 個字', 'error', false)
          return
        }

        const queryPath = {
          causeTypeId: this.newVendor.causeTypeId
        }
        const requestData = {
          name: this.newVendor.name
        }
        apiGuest.SetUpDialog.PostVendorType(
          queryPath,
          requestData
        ).then((res) => {
          if (res.status === 200) {
            this.newVendor.name = ''
            this.isEdited = true
            this.$message({
              type: 'success',
              message: '新增廠商成功'
            })
            this.init()
          } else {
            this.alert('新增廠商失敗', 'error')
            this.init()
          }
          this.newVendor.causeTypeId = 0
          this.newVendor.name = ''
        }).catch((err) => {
          if (err.response.status === 400) {
            this.alert('請勿輸入已存在廠商', 'error')
            this.newVendor.name = ''
            this.newVendor.causeTypeId = 0
            this.canClickButton = true
          }
          console.log('錯誤訊息：', err.response)
        })
      }
    },
    // 編輯
    editRow (tab, row, index) {
      row.edited = true
      row.oldData = row.Name
      if (tab === '訪客事由') {
        this.guestCauseEditing = true
        document.getElementById('button').blur()
        this.$nextTick(() => {
          this.$refs['eventInput' + index].focus()
          this.$refs['eventInput' + index].select()
        })
      } else if (tab === '廠商') {
        this.vendorEditing = true
        document.getElementById('button').blur()
        this.$nextTick(() => {
          this.$refs['vendorInput' + index].focus()
          this.$refs['vendorInput' + index].select()
        })
      }
    },
    // 確定送出編輯
    submitRow (tab, row) {
      if (this.canClickButton) {
        this.canClickButton = false
        if (row.Name === '') {
          this.alert('請輸入內容', 'error')
          return
        }
        if (row.Name && row.Name.length < 2) {
          this.alert('新增失敗，廠商名稱請輸入最少為 2 個字', 'error', false)
          return
        }

        this.fullScreenLoading(true)
        if (tab === '訪客事由') {
          this.editGuestCause(row)
        } else if (tab === '廠商') { this.editVendor(row) }
      }
    },
    // 編輯並送出訪客事由
    editGuestCause (row) {
      const queryPath = {
        id: row.Id
      }
      const requestData = {
        name: row.Name
      }
      apiGuest.SetUpDialog.PatchGuestCauseType(
        queryPath,
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.isEdited = true
          this.$message({
            type: 'success',
            message: '編輯成功'
          })
          this.init()
        }
      }).catch((err) => {
        if (err.response.status === 400) {
          this.alert('請勿輸入已存在訪客事由', 'error')
          this.cancelRow('訪客事由', row)
          this.canClickButton = true
        }
        console.log('錯誤訊息：', err.response)
      })
    },
    // 編輯並送出廠商
    editVendor (row) {
      console.log('編輯廠商', row)
      const queryPath = {
        causeTypeId: row.CauseTypeId,
        id: row.Id
      }
      const requestData = {
        name: row.Name
      }
      apiGuest.SetUpDialog.PatchVendorType(
        queryPath,
        requestData
      ).then((res) => {
        if (res.status === 200) {
          this.isEdited = true
          this.$message({
            type: 'success',
            message: '編輯成功'
          })
          this.init()
        }
      }).catch((err) => {
        if (err.response.status === 400) {
          this.alert('請勿輸入已存在廠商', 'error')
          this.cancelRow('廠商', row)
          this.canClickButton = true
        }
        console.log('錯誤訊息：', err.response)
      })
    },
    // 刪除 msgbox
    deleteRow (tab, row) {
      if (this.canClickButton) {
        this.canClickButton = false
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
        const content = {
          title: '',
          msg1: '',
          msg2: ''
        }
        if (tab === '訪客事由') {
          content.title = '確認刪除訪客事由？'
          content.msg1 = '此訪客事由底下的廠商將自動歸到【其他】。'
          content.msg2 = '刪除後將無法復原，是否確定刪除？'
        } else if (tab === '廠商') {
          content.title = '確認刪除廠商？'
          content.msg1 = '廠商刪除後將無法復原，是否確認刪除？'
          content.msg2 = ''
        }
        this.$msgbox({
          title: content.title,
          customClass: 'message-box-alert',
          message: this.$createElement('p', null, [
            this.$createElement('p', null, content.msg1),
            this.$createElement('p', null, content.msg2),
            this.$createElement('hr', null, '')]),
          showCancelButton: true,
          roundButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消'
        }).then(action => {
          this.fullScreenLoading(true)
          if (tab === '訪客事由') { this.deleteGuestCause(row) } else if (tab === '廠商') { this.deleteVendor(row) }
        }).catch(() => {
        })
      }
    },
    // 刪除訪客事由
    deleteGuestCause (row) {
      this.canClickButton = false
      const queryPath = {
        id: row.Id
      }
      const config = {
        data: {},
        'content-type': 'application/json-patch+json'
      }
      apiGuest.SetUpDialog.DeleteGuestCauseType(
        queryPath,
        config
      ).then((res) => {
        this.fullScreenLoading(false)
        if (res.status === 200) {
          this.isEdited = true
          this.$message({
            type: 'success',
            message: '刪除訪客事由成功'
          })
          this.init()
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.init()
      })
    },
    // 刪除廠商
    deleteVendor (row) {
      this.canClickButton = false
      const queryPath = {
        causeTypeId: row.CauseTypeId,
        id: row.Id
      }
      const config = {
        data: {},
        'content-type': 'application/json-patch+json'
      }
      apiGuest.SetUpDialog.DeleteVendorType(
        queryPath,
        config
      ).then((res) => {
        this.fullScreenLoading(false)
        if (res.status === 200) {
          this.isEdited = true
          this.$message({
            type: 'success',
            message: '刪除成功'
          })
          this.init()
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.init()
      })
    },
    // 取消編輯
    cancelRow (tab, row) {
      if (tab === '訪客事由') {
        this.guestCauseEditing = false
      } else if (tab === '廠商') {
        this.vendorEditing = false
      }
      row.edited = false
      row.Name = row.oldData
    },
    // 篩選廠商
    selectVendor () {
      console.log('selectVendor', this.selectVendorValue)
      if (this.selectVendorValue === 0) {
        this.vendorTypeList = this.allVendorTypeList
      } else {
        this.vendorTypeList = []
        this.allVendorTypeList.forEach(item => {
          if (item.CauseTypeId === this.selectVendorValue) { this.vendorTypeList.push(item) }
        })
        console.log(this.vendorTypeList)
      }
    },
    // 共用alert視窗
    alert (errTxt, type, showfullScreenLoading = true) {
      if (showfullScreenLoading) { this.fullScreenLoading(false) }
      const title = type === 'error' ? '錯誤' : '成功'
      this.$alert(errTxt, title, {
        confirmButtonText: '確定',
        type,
        callback: action => {}
      })
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 全屏loading
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'SetUpDialog_loading'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
#SetUpDialog_main
  .el-dialog__wrapper
    z-index: 2000
  ::v-deep .el-dialog
    +basicDialog
    min-width: 860px
    .el-dialog__body
      padding: 16px
  ::v-deep .el-tabs
    &.setUpTabs
    +basicTabs
    .el-tabs__header
      margin: 0 0 0
    .el-tabs__active-bar
      height: 4px
    .el-tabs__nav-wrap::after
      height: 4px
    .el-tabs__item
      height: 46px
      min-width: 120px
      &:nth-child(3)
        min-width: 100px
    .el-tab-pane
      padding-top: 25px
      .inputWrap
        padding-left: 8px
        text-align: left
        .el-input
          margin-top: 8px
          margin-right: 20px
          width: 305px
      .inputWrap2
        .el-select
          width: 240px
          margin-right: 12px
          .el-input.el-input--suffix
            width: 240px
      .selectVendor
        display: flex
      .tableTitle
        flex: 1
        color: $mainFontColor
        text-align: left
        margin-top: 37px
        margin-bottom: 18px
        font-weight: bold
      .selectVendorOptions
        margin-top: 25px
        width: 300px
  ::v-deep .el-table
    &.list
    +basicTable
    .el-table__row
      td
        height: 58px
</style>
<style lang="sass">
.message-box-alert
  +alert
.SetUpDialog_loading
  z-index: 10000 !important
</style>
